import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        name: 'sign-in',
        path: '/sign-in',
        component: () => import('./sign-in-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    }
]

export default routes;